module.exports = __webpack_public_path__ + "static/img/product-taoyuan.384431b8.png";